import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, finalize, map, Observable, shareReplay, switchMap, throwError } from 'rxjs';
import { IRefreshTokenResponse } from '../interfaces/api-responses/refresh-token-response.interface';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root',
})
export class HttpRequestQueueService {

    private readonly authenticationService = inject(AuthenticationService);
    private cachedRefreshTokenRequestObservable?: Observable<IRefreshTokenResponse | null>;

    public handle401Error(): Observable<IRefreshTokenResponse | null> {
        return this.getRefreshTokenRequestObservable();
    }

    private getRefreshTokenRequestObservable(): Observable<IRefreshTokenResponse | null> {
        let observable: Observable<IRefreshTokenResponse | null>;
        if (this.cachedRefreshTokenRequestObservable) {
            observable = this.cachedRefreshTokenRequestObservable;
        } else {
            this.cachedRefreshTokenRequestObservable = this.authenticationService.refreshToken().pipe(
                shareReplay(),
                finalize(() => delete this.cachedRefreshTokenRequestObservable)
            );
            observable = this.cachedRefreshTokenRequestObservable;
        }
        return observable;
    }

}
